import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { SUPPORTED_LANGS } from "../../i18n";

export default function LanguageSwitcher({ variant = "light" }) {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    const current = SUPPORTED_LANGS.find((l) => l.code === i18n.language?.slice(0, 2)) || SUPPORTED_LANGS[0];

    const buttonClasses =
        variant === "dark"
            ? "text-primary-foreground/85 hover:text-accent"
            : "text-muted-foreground hover:text-primary";

    return (
        <div ref={ref} className="relative" data-testid="language-switcher">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className={`inline-flex items-center gap-1.5 text-xs tracking-wider uppercase transition-colors ${buttonClasses}`}
                data-testid="language-switcher-trigger"
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <Globe size={14} strokeWidth={1.5} />
                <span>{current.short}</span>
                <ChevronDown size={12} strokeWidth={1.5} />
            </button>
            {open && (
                <ul
                    role="listbox"
                    data-testid="language-switcher-menu"
                    className="absolute right-0 mt-2 min-w-[140px] bg-background border border-border shadow-lg z-50"
                >
                    {SUPPORTED_LANGS.map((l) => (
                        <li key={l.code}>
                            <button
                                type="button"
                                onClick={() => {
                                    i18n.changeLanguage(l.code);
                                    setOpen(false);
                                }}
                                data-testid={`language-switcher-option-${l.code}`}
                                className={`w-full text-left px-4 py-2 text-sm tracking-wide transition-colors ${
                                    current.code === l.code
                                        ? "bg-secondary text-primary font-semibold"
                                        : "text-foreground hover:bg-secondary"
                                }`}
                            >
                                {l.label}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
